module.exports = __webpack_public_path__ + "img/p-32.7410d423.png";